const FONT_WEIGHT_CLASS_MAP={bold:"font-bold",semibold:"font-semibold",medium:"font-medium",regular:"font-normal ",light:"font-light"},DEFAULT_FONT_COLOR="text-on-surface";export{DEFAULT_FONT_COLOR,FONT_WEIGHT_CLASS_MAP};
